export default "__VITE_ASSET__Cw3Uq8KB__"